import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from './api/baseApiConfig';
import config from '../config';

const baseUrl = 'aiprompt';

export interface PromptDataModel {
	promptId: string;
	promptContent: string;
	promptTitle: string;
	promptCategory: string;
}

// Create an RTK Query API slice for prompts
export const promptApi = createApi({
	reducerPath: 'promptApi',
	baseQuery: createBaseQuery(`${config.APIM_BASE_URL}/ai`),
	tagTypes: ['Prompts'],
	endpoints: builder => ({
		// Fetch prompts endpoint
		fetchPrompts: builder.query<PromptDataModel[], void>({
			query: () => ({
				url: '/prompt-bank',
				method: 'GET',
			}),
			providesTags: ['Prompts'],
		}),
		// Save prompt endpoint
		savePrompt: builder.mutation<PromptDataModel, Partial<PromptDataModel>>({
			query: (prompt: Partial<PromptDataModel>) => ({
				url: '/prompt-bank',
				method: 'POST',
				body: prompt,
			}),
			invalidatesTags: ['Prompts'],
		}),
		getPromptById: builder.query<PromptDataModel, string>({
			query: (id: string) => ({
				url: `/prompt-bank/${id}`,
				method: 'GET',
			}),
			providesTags: ['Prompts'],
		}),
		deletePrompt: builder.mutation<boolean, PromptDataModel>({
			query: (prompt: PromptDataModel) => ({
				url: `/prompt-bank/${prompt.promptId}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Prompts'],
		}),
	}),
});

export const { useFetchPromptsQuery, useSavePromptMutation, useGetPromptByIdQuery, useDeletePromptMutation } = promptApi;
